export default "__VITE_ASSET__GaR9z$4h__"